import {
  AfterViewInit,
  Component,
  ElementRef,
  ViewEncapsulation,
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { WidgetBaseComponent } from '../widget-base/widget-base.component';

@Component({
  selector: 'widget-embed-code',
  templateUrl: './embed-code.component.html',
  styleUrls: ['./embed-code.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EmbedCodeComponent
  extends WidgetBaseComponent
  implements AfterViewInit
{
  constructor(private _elementRef: ElementRef<HTMLElement>) {
    super();
  }

  get markup(): SafeHtml {
    const css = this.widget?.css ? `<style>${this.widget.css}</style>` : '';
    const html = this.widget?.html || '';
    return this.sanitizeHtml(`${css}${html}`);
  }

  /** <script> injectado via innerHTML não corre; tem de ser criado e anexado ao DOM. */
  ngAfterViewInit(): void {
    if (!this.widget?.js) return;

    const scriptEl = document.createElement('script');
    scriptEl.type = 'text/javascript';
    scriptEl.text = this.widget.js;
    this._elementRef.nativeElement.appendChild(scriptEl);
  }
}
